<template>
  <div>
    <v-card v-if="records" class="mb-3" style="border-radius: 10px;">
      <v-layout align-center justify-space-between class="pa-3 mt-3">
        <v-flex shrink>
          <h3 class="ma-0">{{ flow === 'in' ? 'Infrações Recebidas' : 'Infrações Enviadas' }}</h3>
        </v-flex>
        <v-flex shrink class="text-right font-weight-thin">
          Registros: {{ records.length }}
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="records"
        item-key="id"
        hide-actions
        class="elevation-0 px-3"
      >
        <template slot="items" slot-scope="{ item }">
          <tr @click="toggleExpanded(item.id)">
            <td>{{ item.infraction_id }}</td>
            <td>{{ item.status }}</td>
            <td>{{ item.method }}</td>
            <td>{{ item.type }}</td>
            <td>{{ item.result || '—' }}</td>
            <td>R${{ formatCurrency(item.payment.amount) }}</td>
            <td>{{ mapItemFields(item).parceiro }}</td>
            <td>{{ mapItemFields(item).documento }}</td>
            <td>{{ mapItemFields(item).nome }}</td>
            <td>{{ mapItemFields(item).identificador }}</td>
            <td>
              {{ formatDateTime(item.inserted_at) }}<br/>
            </td>
          </tr>
          <tr v-if="expandedRows.includes(item.id)">
            <td colspan="15">
              <v-expand-transition>
                <div class="pa-3" style="background: #f9f9f9; border: 1px solid #eee;">
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md2 class="pr-3">
                      <h3><strong>Descrição</strong></h3>
                      <p class="my-1" style="white-space: wrap; word-break: break-word; overflow-wrap: break-word;">
                        {{ item.description || '—' }}
                      </p>
                      <h3><strong>Análise</strong></h3>
                      <p class="my-1" style="white-space: wrap; word-break: break-word; overflow-wrap: break-word;">
                        {{ item.analysis || '—' }}
                      </p>
                    </v-flex>
                    <v-flex xs12 sm6 md3 class="pr-3">
                      <h3><strong>Parceiro</strong></h3>
                      <p class="my-1" style="white-space: wrap; word-break: break-word; overflow-wrap: break-word;"><strong>Id: </strong>{{ mapItemFields(item).parceiro_id }}</p>
                      <p class="my-1" style="white-space: wrap; word-break: break-word; overflow-wrap: break-word;"><strong>Documento: </strong>{{ mapItemFields(item).parceiro_documento }}</p>
                    </v-flex>
                    <v-flex xs12 sm6 md3 class="pr-3">
                      <h3><strong>{{'Dados Bancários do Cliente' }}</strong></h3>
                      <p class="my-1"><strong>Código do Banco: </strong>{{ mapItemFields(item).banco_codigo }}</p>
                      <p class="my-1"><strong>Agência: </strong>{{ mapItemFields(item).banco_agencia }}</p>
                      <p class="my-1"><strong>Número da Conta: </strong>{{ mapItemFields(item).banco_numero }}</p>
                      <p class="my-1"><strong>Tipo da Conta: </strong>{{ mapItemFields(item).banco_tipo }}</p>
                    </v-flex>
                    <v-flex xs12 sm6 md2 class="pr-3">
                      <h3><strong>Identificadores</strong></h3>
                      <p class="my-1"><strong>End To End ID: </strong>{{ mapItemFields(item).end_to_end_id }}</p>
                      <p class="my-1"><strong>Bacen ID: </strong>{{ mapItemFields(item).bacen_id }}</p>
                    </v-flex>
                  </v-layout>
                  <div class="mt-4 d-flex flex-wrap">
                    <v-btn
                      v-if="item.flow === 'in' && item.status === 'delivered'"
                      color="#27DABC"
                      dark
                      @click.stop="sendAnalysis(item)"
                      class="mr-2"
                    >
                      Enviar análise
                    </v-btn>
                    <template v-if="item.flow === 'out' && (item.status === 'delivered' || item.status === 'closed')">
                      <v-btn color="error" class="mr-2" @click.stop="openCancelDialog(item)">
                        Cancelar infração
                      </v-btn>
                    </template>
                    <template v-if="item.flow === 'out' && item.result === 'agreed' && item.status === 'closed'">
                      <v-btn color="#27DABC" dark @click.stop="sendChargeback(item)">
                        Solicitar chargeback
                      </v-btn>
                    </template>
                  </div>
                </div>
              </v-expand-transition>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-dialog v-model="analysisDialog" max-width="500px">
        <v-card>
          <v-card-title class="headline">Análise da Infração</v-card-title>
          <v-card-text>
            <v-form ref="analysisFormRef" lazy-validation>
              <v-textarea
                label="Descrição (Obrigatório)"
                v-model="analysisForm.description"
                :rules="[v => !!v || 'Descrição é obrigatória']"
                required
                :counter="2000"
                maxlength="2000"
              />
              <div class="mt-4">
              <p><label class="grey--text text--darken-2 body-1">Resultado (Obrigatório)</label></p>
              <v-btn-toggle
                v-model="analysisForm.result"
                mandatory
                class="mt-1"
              >
                <v-btn
                  v-for="option in resultOptions"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </v-btn>
              </v-btn-toggle>
              <div v-if="!analysisForm.result && analysisFormTouched" class="error--text text-caption mt-1">
                Resultado é obrigatório
              </div>
              </div>
              <v-select
                class="mt-4"
                v-if="analysisForm.result === 'agreed'"
                label="Tipo da infração (Obrigatório)"
                v-model="analysisForm.infractionType"
                :items="infractionTypeOptions"
                item-text="text"
                item-value="value"
                :rules="[v => !!v || 'Tipo da infração é obrigatório']"
                required
              />
            </v-form>
            <div v-if="analysisFormError" class="error--text text-caption mt-2">
              {{ analysisFormError }}
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn color="secondary" text @click="analysisDialog = false">Fechar</v-btn>
            <v-btn color="#27DABC" text @click="submitAnalysis">Enviar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="chargebackDialog" max-width="500px">
        <v-card>
          <v-card-title class="headline">Solicitar Chargeback</v-card-title>
          <v-card-text>
            <v-form ref="chargebackFormRef" lazy-validation>
              <v-textarea
                label="Descrição (Obrigatório)"
                v-model="chargebackForm.description"
                :rules="[v => !!v || 'Descrição é obrigatória']"
                required
                :counter="2000"
                maxlength="2000"
              />

              <v-currency-field
              label="Valor a ser estornado (Obrigatório)"
              v-model="chargebackForm.amount"
              decimal=","
              thousands="."
              type="text"
              :rules="[v => !!v || 'Valor é obrigatório']"
              required
              ></v-currency-field>

              <v-text-field
                label="Motivo"
                v-model="chargebackForm.reason"
                readonly
              />
            </v-form>
            <div v-if="chargebackFormError" class="error--text text-caption mt-2">
              {{ chargebackFormError }}
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn color="secondary" text @click="chargebackDialog = false">Fechar</v-btn>
            <v-btn color="#27DABC" text @click="submitChargeback">Enviar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="cancelDialog" max-width="400px">
        <v-card>
          <v-card-title class="headline">
            Confirmar cancelamento
          </v-card-title>
          <v-card-text>
            Tem certeza que deseja cancelar a infração?
            <br />
            <small>*Só pode cancelar se não tiver recebido o chargeback</small>

            <v-form ref="cancelFormRef" lazy-validation>
              <v-textarea
                class="mt-3"
                label="Motivo do cancelamento (obrigatório)"
                v-model="cancelForm.canceled_reason"
                :rules="[v => !!v || 'Motivo é obrigatório']"
                required
                :counter="255"
                maxlength="255"
              />
            </v-form>
            <div v-if="cancelFormError" class="error--text text-caption mt-2">
              {{ cancelFormError }}
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn color="secondary" text @click="cancelDialog = false">Fechar</v-btn>
            <v-btn color="error" @click="submitCancel">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import DefaultFilterDate from "./components/filters/DefaultFilterDate"
import utils from "./shared/Utils"
export default {
  name: 'AdminInfractionsList',
  props: {
    records:
    {
      type: Array,
      required: true
    },
    flow: {
      type: String,
      required: true
    }
  },
  components: {
    DefaultFilterDate
  },
  data() {
    return {
      analysisRecord: null,
      analysisFormError: '',
      chargebackDialog: false,
      cancelDialog: false,
      analysisDialog: false,
      analysisFormTouched: false,
      analysisForm: {
        description: '',
        result: '',
        infractionType: ''
      },
      chargebackForm: {
        description: '',
        amount: '',
        reason: 'fraud'
      },
      chargebackFormError: '',
      cancelForm: {
        canceled_reason: ''
      },
      cancelFormError: '',
      expandedRows: [],
      headersIn: [
        { text: 'ID da infração', value: 'infraction_id' },
        { text: 'Status', value: 'status' },
        { text: 'Método', value: 'method' },
        { text: 'Tipo', value: 'type' },
        { text: 'Resultado', value: 'result' },
        { text: 'Valor', value: 'amount' },
        { text: 'Parceiro', value: 'sender_name' },
        { text: 'Documento (cliente)', value: 'sender_tax_id' },
        { text: 'Nome (cliente)', value: 'sender_name' },
        { text: 'ID da Transação Bancária', value: 'bank_transaction_id' },
        { text: 'Data', value: 'inserted_at' }
      ],
      headersOut: [
        { text: 'ID da infração', value: 'infraction_id' },
        { text: 'Status', value: 'status' },
        { text: 'Método', value: 'method' },
        { text: 'Tipo', value: 'type' },
        { text: 'Resultado', value: 'result' },
        { text: 'Valor', value: 'amount' },
        { text: 'Parceiro', value: 'sender_name' },
        { text: 'Documento (cliente)', value: 'receiver_tax_id' },
        { text: 'Nome (cliente)', value: 'receiver_name' },
        { text: 'ID da Transferência', value: 'company_wire_id' },
        { text: 'Data', value: 'inserted_at' }
      ],
      resultOptions: [
        { text: 'Aprovado', value: 'disagreed' },
        { text: 'Reprovado', value: 'disagreed' }
      ],
      infractionTypeOptions: [
        { text: 'Furto de identidade', value: 'identity' },
        { text: 'Conta laranja', value: 'mule' },
        { text: 'Golpe', value: 'scam' },
        { text: 'Outro', value: 'other' }
      ],
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    toggleExpanded(itemId) {
      const index = this.expandedRows.indexOf(itemId)
      if (index !== -1) {
        this.expandedRows.splice(index, 1)
      } else {
        this.expandedRows.push(itemId)
      }
    },
    extractErrors(response) {
      try {
        const data = JSON.parse(response.bodyText || '{}')
        const messages = []
        if (data.errors) {
          for (const field in data.errors) {
            const fieldMessages = data.errors[field]
            fieldMessages.forEach(msg => {
              const translatedMsg = this.i18n(msg)
              messages.push(`${translatedMsg}`)
            })
          }
        } else {
          messages.push(this.i18n(data.error))
        }

        return messages
      } catch (e) {
        return [this.i18n('Erro inesperado ao processar a resposta.')]
      }
    },
    mapItemFields(item) {
      const isIn = item.flow === 'in'
      const payment = item.payment || {}
      const partner = payment.partner || {}

      return {
        parceiro: partner.social_name || '—',
        parceiro_id: partner.id || '—',
        parceiro_documento: partner.document_number || '—',

        documento: isIn ? payment.sender_tax_id || '—' : payment.receiver_tax_id || '—',
        nome: isIn ? payment.sender_name || '—' : payment.receiver_name || '—',
        identificador: isIn ? payment.bank_transaction_id || '—' : payment.company_wire_id || '—',

        banco_codigo: isIn ? payment.sender_bank_code || '—' : payment.receiver_bank_code || '—',
        banco_agencia: isIn ? payment.sender_branch_code || '—' : payment.receiver_branch_code || '—',
        banco_numero: isIn ? payment.sender_account_number || '—' : payment.receiver_account_number || '—',
        banco_tipo: isIn ? payment.sender_account_type || '—' : payment.receiver_account_type || '—',

        end_to_end_id: payment.end_to_end_id || '—',
        bacen_id: item.bacen_id || '—',
      }
    },
    formatCurrency(value) {
      if (!value) return '0,00'
      return (value / 100).toFixed(2).replace('.', ',')
    },
    formatDateTime(datetime) {
      return utils.dbDateTimeToHuman(datetime)
    },
    sendAnalysis(item) {
      this.analysisRecord = item
      this.analysisDialog = true
      this.analysisForm = {
        description: '',
        result: '',
        infractionType: ''
      }
      this.analysisFormError = ''
      this.analysisFormTouched = false
      this.$nextTick(() => {
        if (this.$refs.analysisFormRef) {
          this.$refs.analysisFormRef.resetValidation()
        }
      })
    },
    submitAnalysis() {
      this.analysisFormTouched = true
      const formValid = this.$refs.analysisFormRef.validate()
      if (!formValid || !this.analysisForm.result) {
        return
      }
      const analysis = {
        analysis: this.analysisForm.description,
        result: this.analysisForm.result
      }
      if (this.analysisForm.result === 'agreed') {
        analysis.fraud_type = this.analysisForm.infractionType
      }
      const payload = { analysis }
      const token = this.$cookies.get('api_token')
      const url = this.$root.urls.admin__analyze_infraction.replace('ID', this.analysisRecord.id)
      this.$http.post(url, payload, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(() => {
          this.analysisDialog = false
          this.analysisForm = { description: '', result: '', infractionType: '' }
          this.analysisFormTouched = false
          this.$emit('refresh-data')
        })
        .catch(error => {
          const messages = this.extractErrors(error)
          this.analysisFormError = messages.join(', ')
        })
    },
    openCancelDialog(item) {
      this.cancelRecord = item
      this.cancelDialog = true
      this.cancelForm = {
        canceled_reason: ''
      }
      this.cancelFormError = ''
      this.$nextTick(() => {
        if (this.$refs.cancelFormRef) {
          this.$refs.cancelFormRef.resetValidation()
        }
      })
    },
    sendChargeback(item) {
      this.chargeBackRecord = item
      this.chargebackDialog = true
      this.chargebackFormError = ''
      this.chargebackForm = {
        description: '',
        amount: '',
        reason: 'fraud'
      }
      this.$nextTick(() => {
        if (this.$refs.chargebackFormRef) {
          this.$refs.chargebackFormRef.resetValidation()
        }
      })
    },
    submitChargeback() {
      const formValid = this.$refs.chargebackFormRef.validate()
      if (!formValid) return
      const token = this.$cookies.get('api_token')
      const payload = {
        description: this.chargebackForm.description,
        amount: String(this.chargebackForm.amount),
        reason: this.chargebackForm.reason,
        reference_id: this.chargeBackRecord.payment.end_to_end_id,
        infraction_id: this.chargeBackRecord.id,
        company_wire_id: this.chargeBackRecord.payment.company_wire_id
      }
      const url = this.$root.urls.admin__request_chargeback
      this.$http.post(url, payload, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(() => {
        this.chargebackDialog = false
        this.chargebackForm = { description: '', amount: '', reason: 'fraud' }
        this.$emit('refresh-data')
      })
      .catch(error => {
        const messages = this.extractErrors(error)
        this.chargebackFormError = messages.join(', ')
      })
    },
    submitCancel() {
      const formValid = this.$refs.cancelFormRef.validate()
      if (!formValid) return
      const token = this.$cookies.get('api_token')
      const url = this.$root.urls.admin__cancel_infraction.replace('ID', this.cancelRecord.id)
      const payload = {
        canceled_reason: this.cancelForm.canceled_reason
      }
      this.$http.put(url, payload, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(() => {
        this.cancelDialog = false
        this.cancelForm.canceled_reason = ''
        this.$emit('refresh-data')
      })
      .catch(error => {
        const messages = this.extractErrors(error)
        this.cancelFormError = messages.join(', ')
      })
    }
  },
  computed: {
    headers() {
      if (!this.records.length) return []
      const first = this.records.find(r => !!r.flow)
      return first && first.flow === 'in' ? this.headersIn : this.headersOut
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/AdminInfractionsList.vue